import usePermittedQuery from '_api/queries/usePermittedQuery';
import { Therapist } from '_api/types';
import { ACCOUNT_TYPE } from '_constants';

import { UseGetAllPageSizeProps } from '../types';

export const GET_ALL_ACTIVE_THERAPIST_KEY = 'get-all-active-therapist';

export const useGetAllActiveTherapist = ({
  page = 0,
  size = 10,
}: UseGetAllPageSizeProps) => {
  return usePermittedQuery<Therapist[]>(
    [
      ACCOUNT_TYPE.ADMIN,
      ACCOUNT_TYPE.ORG_ADMIN,
      ACCOUNT_TYPE.HOS_ADMIN,
      ACCOUNT_TYPE.THERAPIST,
    ],
    () => `/therapist/active?page=${page}&size=${size}`,
    {},
    [GET_ALL_ACTIVE_THERAPIST_KEY],
    {
      enabled:
        typeof page === 'number' && typeof size === 'number' && page >= 0 && size >= 0,
      refetchOnWindowFocus: false,
    },
  );
};
